import { render, staticRenderFns } from "./QuizStats.vue?vue&type=template&id=0401df9a&scoped=true"
import script from "./QuizStats.vue?vue&type=script&lang=js"
export * from "./QuizStats.vue?vue&type=script&lang=js"
import style0 from "./QuizStats.vue?vue&type=style&index=0&id=0401df9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0401df9a",
  null
  
)

export default component.exports